import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const SubStepContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "15px",
  gap: "15px",
  fontFamily: "Arial, sans-serif",
});

export const Step = styled(Box)(({ theme, active }) => ({
  display: "flex",
  alignItems: "center",
  gap: "5px",
  fontSize: "14px",
  fontWeight: "bold",
  color: active ? theme.palette.jigsaw.green : theme.palette.text.secondary,
}));

export const StepCircle = styled(Box)(({ theme, status }) => ({
  width: "22px",
  height: "22px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  backgroundColor:
    status === "active" || status === "completed"
      ? theme.palette.jigsaw.green
      : theme.palette.grey[400],
  color: "#fff",
  fontSize: "12px",
  fontWeight: "bold",
}));

export const StepLabel = styled(Typography)({
  fontSize: "14px",
});

export const Arrow = styled(Typography)({
  fontSize: "16px",
  color: "#999",
});